import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  buttons: {
    flexDirection: "row",
  },
});

export { style };
